export const SECOND_IN_MILLISECONDS = 1000;
export const MINUTE_IN_MILLISECONDS = SECOND_IN_MILLISECONDS * 60;
export const HOUR_IN_MILLISECONDS = MINUTE_IN_MILLISECONDS * 60;
export const DAY_IN_MILLISECONDS = HOUR_IN_MILLISECONDS * 24;
export const MONTH_IN_MILLISECONDS = DAY_IN_MILLISECONDS * 30;

export const getTotalDayInMonth = (year: number, month: number) => {
  return new Date(year, month, 0).getDate();
};

export const millisecondsToTime = (duration: number) => {
  const milliseconds = Math.floor((duration % 1000) / 100);
  const seconds = Math.floor((duration / 1000) % 60);
  const minutes = Math.floor((duration / (1000 * 60)) % 60);
  const hours = Math.floor((duration / (1000 * 60 * 60)) % 24);

  return { hours, minutes, seconds, milliseconds };
};

export const timeToMilliseconds = (time: string) => {
  if (!time) return 0;
  const [hours = 0, minutes = 0, seconds = 0] = time.split(':').map(Number);
  return (hours * 60 * 60 + minutes * 60 + seconds) * 1000;
};

export const convertTimeToHours = (time: string) => {
  if (!time) return 0;

  const splittedTime = time.split(':');

  const seconds = Number(splittedTime?.[2] || 0);
  const minutes = Number(splittedTime?.[1] || 0);
  const hours = Number(splittedTime?.[0] || 0);

  const secondsToHours = seconds / 60 / 60;
  const minutesToHours = minutes / 60;

  return Number((hours + minutesToHours + secondsToHours).toFixed(2));
};

export const convertMillisecondsToHours = (milliseconds: number) => {
  const hourInMillisecond = 1000 * 60 * 60;
  return milliseconds / hourInMillisecond;
};
